import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

interface RouterAuthGuardProps {
  children: React.ReactNode;
  redirectTo: string;
}

const RouterAuthGuard = ({ children, redirectTo }: RouterAuthGuardProps): JSX.Element => {
  const auth = useAuth();

  if (auth?.isLoading || auth?.activeNavigator) {
    return <>{children}</>;
  }

  if (!auth?.isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default RouterAuthGuard;
